import React, { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useCustomAuth } from '../../hooks/useCustomAuth';

export type RequireAuthenticationProps = PropsWithChildren<{
  loginUrl?: string;
}>;

export default function RequireAuthentication({
  children,
  loginUrl = '/login',
}: RequireAuthenticationProps): JSX.Element {
  const { isAuthenticated } = useCustomAuth();
  const location = useLocation();
  if (!isAuthenticated) {
    return (
      <Navigate
        state={{ from: location }}
        to={loginUrl}
      />
    );
  }

  return <>{children}</>;
}
